import React, { useState } from 'react';

import GradeClassNumberLabel from '@/components/ui/formats/GradeClassNumberLabel';
import Checkbox from '@/components/ui/forms/Checkbox';

import styles from './StudentInformation.module.scss';

interface Props {
  organizationMembershipCode: string;
  organizationName: string;
  name: string;
  grade: string;
  classNameLabel: string | null;
  attendanceNumber: number | null;
  onCheckboxChange: (checked: boolean) => void;
}

const StudentInformation: React.FC<Props> = ({
  organizationMembershipCode,
  organizationName,
  name,
  grade,
  classNameLabel,
  attendanceNumber,
  onCheckboxChange,
}) => {
  const [checked, setChecked] = useState(false);

  return (
    <div
      className={styles.StudentConfirmForm}
      data-testid="student-information"
    >
      <div className={styles.StudentConfirmForm__OrganizationMembershipCode}>
        {organizationMembershipCode}
      </div>
      <div className={styles.StudentConfirmForm__StudentInformation}>
        <div
          className={
            styles.StudentConfirmForm__StudentInformation__OrganizationName
          }
        >
          {organizationName}
        </div>
        <GradeClassNumberLabel
          gradeLabel={grade}
          classNameLabel={classNameLabel ?? undefined}
          attendanceNumberLabel={attendanceNumber ?? undefined}
        />
        <div
          className={styles.StudentConfirmForm__StudentInformation__StudentName}
        >
          {name}
        </div>
      </div>

      <div className={styles.StudentConfirmForm__CheckBoxArea}>
        <Checkbox
          checked={checked}
          onChange={(_) => {
            setChecked(!checked);
            onCheckboxChange(!checked);
          }}
          disabled={false}
          role="checkbox"
        >
          <div className={styles.StudentConfirmForm__Checkbox__Text}>
            私はこの生徒の保護者であることを確認しました
          </div>
        </Checkbox>
      </div>
    </div>
  );
};

export default StudentInformation;
